// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__4YBNC","balanceAndInvestmentDetails":"Dashboard_balanceAndInvestmentDetails__oBjYY","investmentAndOverview":"Dashboard_investmentAndOverview__6e04I"};